import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupDateFilter } from './useSignupDateFilter';

export const SignupDateFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, signupDateOptions } = useSignupDateFilter({ setFilters });

  return (
    <Formik
      initialValues={{ signupDaysSinceJoined: value || signupDateOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupDaysSinceJoined"
          label="Signup date"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={signupDateOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SignupDateFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

SignupDateFilter.defaultProps = {
  value: null,
};
